import React from "react";
import { FormProvider, useForm } from "react-hook-form";

import { Button, DateRangePickerWidget } from "@synthesis/shared-ui";

import type { SearchDto } from "../projects-page.lib";

type CustomDateFilterProps = {
  searchPatternState: SearchDto | Record<string, never>;
  setSearchPatternState: React.Dispatch<React.SetStateAction<SearchDto | Record<string, never>>>;
};

export const CustomDateFilter = ({ searchPatternState, setSearchPatternState }: CustomDateFilterProps) => {
  const methods = useForm({ defaultValues: { columnFilter: null as { start: number; end: number } | null } });

  const handleSubmit = () => {
    const columnFilter = methods.getValues("columnFilter");
    if (!columnFilter) return;

    const searchPatterns: SearchDto = {};
    const endTime = columnFilter.end + 86359;
    searchPatterns.CREATED_AT = {
      value: [columnFilter.start.toString(), endTime.toString()],
      pattern: "RANGE",
    };
    setSearchPatternState((prevState) => ({
      ...prevState,
      ...searchPatterns,
    }));
  };

  const resetFilters = () => {
    setSearchPatternState((prevState) => {
      const newState = { ...prevState };
      delete newState.CREATED_AT;
      return newState;
    });
    methods.reset();
  };

  React.useEffect(() => {
    if (searchPatternState?.CREATED_AT) {
      methods.setValue("columnFilter", {
        start: Number(searchPatternState.CREATED_AT.value?.[0]),
        end: Number(searchPatternState.CREATED_AT.value?.[1]) - 86359,
      });
    }
  }, [searchPatternState, methods]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <DateRangePickerWidget name="columnFilter" controlled />
        <div className="flex justify-between p-2">
          <Button theme="primary" type="submit">
            Применить
          </Button>
          <Button onClick={resetFilters}>Сбросить</Button>
        </div>
      </form>
    </FormProvider>
  );
};
